// Number and time formatting shared by the console's pages and charts.

/** A comparison the stats routes return per metric (docs/console-api.md `Kpi`). */
export interface Trend {
  now: number;
  prev: number;
  usual: number | null;
  week?: number;
}

export const fmt = {
  int: (n: number | undefined | null) => (n === undefined || n === null ? "–" : Math.round(n).toLocaleString("en-US")),
  compact: (n: number | undefined | null) =>
    n === undefined || n === null ? "–" : Intl.NumberFormat("en-US", { notation: "compact", maximumFractionDigits: 1 }).format(n),
  pct: (n: number | undefined | null) => (n === undefined || n === null ? "–" : `${n.toFixed(n < 10 ? 1 : 0)}%`),
  bytes: (n: number | undefined | null) => {
    if (n === undefined || n === null) return "–";
    const u = ["B", "KB", "MB", "GB", "TB"];
    let i = 0;
    let v = n;
    while (v >= 1024 && i < u.length - 1) {
      v /= 1024;
      i++;
    }
    return `${v < 10 && i ? v.toFixed(1) : Math.round(v)} ${u[i]}`;
  },
  ms: (n: number | undefined | null) => (n === undefined || n === null ? "–" : n < 1000 ? `${Math.round(n)} ms` : `${(n / 1000).toFixed(1)} s`),
};

/** "3 min ago", "yesterday", or a date. */
export function ago(ms: number | null | undefined, now = Date.now()): string {
  if (!ms) return "—";
  const s = Math.round((now - ms) / 1000);
  if (s < 5) return "just now";
  if (s < 60) return `${s} s ago`;
  const m = Math.round(s / 60);
  if (m < 60) return `${m} min ago`;
  const h = Math.round(m / 60);
  if (h < 24) return `${h} h ago`;
  const d = Math.round(h / 24);
  if (d === 1) return "yesterday";
  if (d < 30) return `${d} days ago`;
  return new Date(ms).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
}

export const when = (ms: number | null | undefined) => (ms ? new Date(ms).toLocaleString() : "—");

/** The last `n` UTC days, oldest first, as "YYYY-MM-DD". */
export function lastDays(n: number, now = Date.now()): string[] {
  return Array.from({ length: n }, (_, i) => new Date(now - (n - 1 - i) * 86_400_000).toISOString().slice(0, 10));
}
